<template>
  <div v-cloak v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      title="Modify User"
      :visible.sync="editUserDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="500px"
      @opened="opened"
      size="small">

      <el-form
        label-position="left"
        label-width="120px"
      >
        <el-form-item label="EBP Username: " required>
          <el-input v-model="userDTO.ebp_user_name" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Name CN: " required>
          <el-input v-model="userDTO.name_cn" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Name EN: " required>
          <el-input v-model="userDTO.name_en" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Email: " required>
          <el-input v-model="userDTO.email" size="small"></el-input>
        </el-form-item>
        <el-form-item label="Enable: " required>
          <el-switch
            v-model="userDTO.enabled"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="CaseSwitch: " required>
              <el-switch
                v-model="userDTO.case_enable"
                :disabled="!disableCaseSwitch"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="EmailSwitch: " required>
              <el-switch
                v-model="userDTO.email_enable"
                :disabled="!disableEmailSwitch||disableEmailSwitchByCaseSwitch"
                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
          </el-col>
         
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer">
              <el-button type="success" @click="saveUser">Save</el-button>
              <el-button @click="editUserDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import util from '@/util/util.js'

  export default {
    components: {},
    props: {
      userInfo: {
        type: Object,
        required: true,
        default: () => {
        }
      }
    },
    data() {
      return {
        editUserDialogVisible: false,
        userDTO: {
          enabled: true,
          email_enable:false,
          case_enable:false
        },
        dataLoading: false
      }
    },
    computed: {
      //监听Enable的值，控制eamil 和case
      disableCaseSwitch(){
        if(!this.userDTO.enabled){
          this.closeEnable()
        }
        return this.userDTO.enabled
      },
      disableEmailSwitch(){
        return this.userDTO.enabled 
      },
      //监听CaseSwitch 控制emailSwitch
      disableEmailSwitchByCaseSwitch(){
        if(!this.caseActiveVaule){
          this.closeEmail()
        }
        return !this.caseActiveVaule
      },
      caseActiveVaule(){
        return this.userDTO.case_enable
      },
      enableActiveVaule(){
        return this.userDTO.enabled;
      },
      enableInactiveValue(){
        return !this.userDTO.enabled;
      }
    },
    created() {
    },


    methods: {
      closeEnable(){
        this.userDTO.case_enable = false
        this.userDTO.email_enable = false
      },
      closeEmail(){
        this.userDTO.email_enable = false
      },
      opened() {
        this.userDTO = util.deepClone(this.userInfo);
        this.userDTO.enabled = this.userDTO.enabled === 'true';
        this.userDTO.email_enable = this.userDTO.email_enable == 1;
        this.userDTO.case_enable = this.userDTO.case_enable == 1;
      },
      showEditUserDialog() {
        this.editUserDialogVisible = true;
      },
      hideEditUserDialog() {
        this.editUserDialogVisible = false;
      },
      saveUser() {
        let user = {};
        user.appKey = this.appKey;
        user.ebpUserName = this.userDTO.ebp_user_name;
        user.email = this.userDTO.email;
        console.log(this.userDTO)
        //添加case 和email开关
        if(this.userDTO.case_enable.toString()==='true'){
          user.caseEnable = true
        }else{
          user.caseEnable = false
        }
        if(this.userDTO.email_enable.toString()==='true'){
          user.emailEnable = true
        }else{
          user.emailEnable = false
        }
        
        user.enabled = this.userDTO.enabled;
        user.id = this.userDTO.id;
        user.nameCn = this.userDTO.name_cn;
        user.nameEn = this.userDTO.name_en;
        if (this.validateUser(user)) {
          let url = this.baseAcsUrl + '/acs/user/update-user';
          this.dataLoading = true;

          this.http.put(url, user).then(resp => {
            this.$message.success('Successful operation ');
            this.editUserDialogVisible = false;
            this.dataLoading = false;
            this.$emit("saveSuccess");
          }).catch(error => {
            this.dataLoading = false;
            console.info(error);
            this.$emit("saveFail");
            this.$message.warning('Operation failure');
          });
        }
      },
      validateUser(user) {
        if (!user.ebpUserName) {
          this.$message.warning('Please input EBP Username');
          return false;
        }
        if (!user.nameCn) {
          this.$message.warning('Please input Name CN');
          return false;
        }
        if (!user.nameEn) {
          this.$message.warning('Please input Name EN');
          return false;
        }

        if (!user.email) {
          this.$message.warning('Please input Email');
          return false;
        }

        let email = user.email;
        let reg = new RegExp("^[a-zA-Z0-9_-]+[a-zA-Z0-9_\\.-]*@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$");
        if (!reg.test(email)) { //正则验证不通过，格式不对
          this.$message.warning('Please input valid Email');
          console.log(false);
          return false;
        }
        return true;
      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }

  .breadcrumb {
    background-color: transparent !important;
    margin-bottom: 0px;
  }

  .title {
    margin-left: 16px;
    font-size: 20px;
  }

  .el-form-item /deep/ .el-select {
    display: inline-block;
    width: 86%;
  }

  .add-banner-group /deep/ .el-form-item__label {
    width: 148px !important;
  }

  .add-banner-group /deep/ .el-form-item__content {
    margin-left: 148px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/user/dialog/edit_user.vue